module.exports = __webpack_public_path__ + "img/20200609_130143.6a70af3d.jpg";